import React from 'react';
import {MentionsInput, Mention} from 'react-mentions';
import { connect } from 'react-redux';
import {getMentionedUserIds} from '../utils/StringUtils';

@connect(state => ({    
    users: state.users.users
}))
export default class NoteWithMentions extends React.Component {	    

	constructor(props){
		super(props);
		this.state = {
			textValue: this.props.value
		}
	}
	componentWillReceiveProps(nextProps){
		this.setState({
			textValue : nextProps.value
		})		
	}

	handleChange(e){
        this.setState({
            textValue: e.target.value
        });

		var mentionedUsers = getMentionedUserIds(e.target.value);       

        this.props.noteChanged(e.target.value, mentionedUsers);
	}

	displayTransform(id, display){
		return '@' + display;
	}

	renderSuggestion(id, display){
		return '@' + display;
	}

	onBlur(){		
		if (this.props.onBlur){
			this.props.onBlur();
		}
	}

	onFocus(){
		if (this.props.onFocus){
			this.props.onFocus();
		}
	}
	
	render() {			

		var users = [];

		this.props.users.map( user => {
			users.push({
				id: user.id,
				display : user.firstName + ' ' + user.lastName
			})
		});		  

	    return (
	        <MentionsInput
                className={this.props.className ? this.props.className : 'react-mentions'}
				value={this.state.textValue}
				onChange={this.handleChange.bind(this)}
				displayTransform={this.displayTransform}
				placeholder={"Add a note. (Mention people with @)"}
				onBlur={this.onBlur.bind(this)}
				onFocus={this.onFocus.bind(this)}
  	        >
  	          	<Mention data={ users } renderSuggestion={this.renderSuggestion}/>
  	        </MentionsInput>    
	    );
	  }
}


// WEBPACK FOOTER //
// ./app/components/NoteWithMentions.js